const GLASS = {
  color: "#1b2530",
  metalness: 0.1,
  roughness: 0.05,
  transparent: true,
  opacity: 0.72,
  clearcoat: 1,
  envMapIntensity: 1.5
};
const HEADLIGHT = {
  color: "#e6edf5",
  metalness: 0.35,
  roughness: 0.08,
  clearcoat: 1
};
const TAIL_LIGHT = {
  color: "#8e2126",
  metalness: 0.3,
  roughness: 0.12,
  clearcoat: 1,
  emissive: "#3a0a0c",
  emissiveIntensity: 0.7
};
const RUBBER = {
  color: "#17191c",
  metalness: 0.02,
  roughness: 0.88
};
const TREAD_GROOVE = {
  color: "#0a0b0d",
  metalness: 0,
  roughness: 0.95
};
const ALLOY = {
  color: "#dfe4ea",
  metalness: 0.82,
  roughness: 0.22,
  envMapIntensity: 1.2
};
const RIM_BARREL = {
  color: "#3c424a",
  metalness: 0.85,
  roughness: 0.42
};
const BRAKE_DISC = {
  color: "#6b7279",
  metalness: 0.9,
  roughness: 0.34
};
const CALIPER = {
  color: "#7c3a3a",
  metalness: 0.4,
  roughness: 0.5
};
const HUB = {
  color: "#8d949c",
  metalness: 0.9,
  roughness: 0.38
};
const STEEL_WHEEL = {
  color: "#b9bfc6",
  metalness: 0.72,
  roughness: 0.4,
  envMapIntensity: 0.95
};
const CAVITY = {
  color: "#14171a",
  metalness: 0.1,
  roughness: 0.85
};
const BRAKE_DRUM = {
  color: "#4d5359",
  metalness: 0.65,
  roughness: 0.6
};
const HIGHLIGHT_COLOR = "#0ea5e9";
export {
  ALLOY,
  BRAKE_DISC,
  BRAKE_DRUM,
  CALIPER,
  CAVITY,
  GLASS,
  HEADLIGHT,
  HIGHLIGHT_COLOR,
  HUB,
  RIM_BARREL,
  RUBBER,
  STEEL_WHEEL,
  TAIL_LIGHT,
  TREAD_GROOVE
};
